module.exports = __webpack_public_path__ + "img/setChecked2.7c07d850.png";